// Scroll-snap carousel: prev/next buttons page the [data-carousel-track] by its visible width and disable at either end.
class SCarousel extends HTMLElement {
  #ac;
  #track;
  #prev;
  #next;
  #frame = 0;

  connectedCallback() {
    this.#ac = new AbortController();
    const opts = { signal: this.#ac.signal };
    this.#track = this.querySelector('[data-carousel-track]');
    this.#prev = this.querySelector('[data-carousel-prev]');
    this.#next = this.querySelector('[data-carousel-next]');
    if (!this.#track) return;

    this.#prev?.addEventListener('click', () => this.#page(-1), opts);
    this.#next?.addEventListener('click', () => this.#page(1), opts);
    this.#track.addEventListener('scroll', () => this.#scheduleUpdate(), { ...opts, passive: true });
    window.addEventListener('resize', () => this.#scheduleUpdate(), opts);
    this.#updateButtons();
  }

  disconnectedCallback() {
    this.#ac?.abort();
    cancelAnimationFrame(this.#frame);
  }

  #page(direction) {
    const track = this.#track;
    if (!track) return;
    const rtl = getComputedStyle(track).direction === 'rtl' ? -1 : 1;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    track.scrollBy({ left: direction * rtl * track.clientWidth * 0.9, behavior: reduceMotion ? 'auto' : 'smooth' });
  }

  #scheduleUpdate() {
    cancelAnimationFrame(this.#frame);
    this.#frame = requestAnimationFrame(() => this.#updateButtons());
  }

  #updateButtons() {
    const track = this.#track;
    if (!track) return;
    const position = Math.abs(track.scrollLeft);
    const max = track.scrollWidth - track.clientWidth - 2;
    if (this.#prev instanceof HTMLButtonElement) this.#prev.disabled = position <= 2;
    if (this.#next instanceof HTMLButtonElement) this.#next.disabled = position >= max;
  }
}

customElements.define('s-carousel', SCarousel);
